<shared-modal [modalTitle]="'New analysis'">
  <ng-container modalBody>
    @if (isTenantSelectVisible) {
      <div class="m-b-32">
        <label for="selectedTenantId">Analyze a process from the following tenant:</label>
        <mat-select name="selectedTenantId" [value]="selectedTenantId" (valueChange)="onTenantChanged($event)">
          @for (tenant of tenants; track tenant) {
            <mat-option [value]="tenant.id">{{ tenant.label }}</mat-option>
          }
        </mat-select>
      </div>
    }

    @if (platform != null) {
      <div class="section upload-info-box">
        <ul class="bullets">
          <li>Export a process log from {{ platform.label }} in <span [innerHtml]="platform.logFileTypesHtml"></span> format and upload it here.</li>
          @if (platform.isUiPath) {
            <li>If you use verbose logging, Pointee will provide you with even more detailed data and deeper insights.</li>
          } @else {
            <li>To increase the speed of upload you may compress the <span [innerHtml]="platform.logFileTypesHtml"></span> file into a <b>*.zip</b> file first.</li>
          }
          @if (platform.isUiPath) {
            <li>If you’re uploading logs from multiple days, compress the files into one <b>*.zip</b> file first.</li>
          }
          <li>You can upload multiple processes at once.</li>
        </ul>
      </div>
      <app-file-drop-box
        (fileDrop)="onFileDrop($event)"
        [allowMultipleFiles]="true"
        [acceptedFileTypes]="platform.acceptedFileTypes"
        [acceptedFileTypesText]="platform.logFileTypesText"
      ></app-file-drop-box>
    }
  </ng-container>
</shared-modal>
